import { type ReactNode } from 'react'
import { cn } from '#app/utils/misc'

/**
 * Long-form reading surface for guides, comparisons and course lessons.
 * Instrument Sans body, Bricolage Grotesque headings, IBM Plex Mono code —
 * tuned for reading comfort (this is a content site first).
 */
export function Prose({
	children,
	className,
}: {
	children: ReactNode
	className?: string
}) {
	return (
		<div
			className={cn(
				'prose prose-neutral max-w-none',
				// body
				'prose-p:text-[#33323A] prose-p:leading-[1.75] prose-li:text-[#33323A]',
				// headings → display font
				'prose-headings:font-display prose-headings:tracking-[-0.02em] prose-headings:text-ink',
				'prose-h2:mt-13 prose-h2:mb-4 prose-h2:text-[29px] prose-h3:text-xl',
				// links + strong
				'prose-a:text-brand prose-a:no-underline hover:prose-a:underline prose-strong:text-ink prose-strong:font-semibold',
				// inline code
				'prose-code:font-mono prose-code:text-[0.9em] prose-code:before:content-none prose-code:after:content-none',
				'prose-code:rounded-[5px] prose-code:bg-[#F0EDE6] prose-code:px-1.5 prose-code:py-0.5',
				className,
			)}
		>
			{children}
		</div>
	)
}
